import React, { useState } from "react";
import { Survey } from "./survey-types";
import { storageService } from "../../services/StorageService";
import { Link, useNavigate } from "react-router-dom";
import ConfirmationModal from "@/components/ConfirmationModal";

interface SurveyNavbarProps {
  survey: Survey;
}

const SurveyNavbar: React.FC<SurveyNavbarProps> = ({ survey }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleDeleteSurvey() {
    storageService.deleteSurvey(survey.id);
    //setIsModalOpen(false);
    navigate("/workspaces/VzSj79");
  }

  return (
    <>
      <ul className="flex flex-row gap-4 sm:flex-col sm:w-48 w-full overflow-hidden">
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <Link to="./definition">Definition</Link>
        </li>
        <li>
          <hr className="hidden sm:block mr-10" />
        </li>
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <Link to="./results">Responses</Link>
        </li>
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <Link to="./analysis">Analysis</Link>
        </li>
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <Link to="./export">Export</Link>
        </li>
        <li>
          <hr className="hidden sm:block mr-10" />
        </li>
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <Link to="./edit">
            Edit <span className="sm:inline hidden">Survey</span>
          </Link>
        </li>
        <li className="mr-4 text-lg hover:text-slate-400 whitespace-nowrap">
          <button onClick={() => setIsModalOpen(true)}>
            Delete <span className="sm:inline hidden">Survey</span>
          </button>
        </li>
      </ul>
      <ConfirmationModal
        isOpen={isModalOpen}
        title="Confirm Delete"
        message="Are you sure you want to delete this survey? This action cannot be undone."
        onConfirm={handleDeleteSurvey}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default SurveyNavbar;
SurveyNavbar;
